import React from 'react';
import DashboardContainer from '../customDashboards/dashboardContainer';
import { PRECONFIGURED_TYPES } from '../customDashboards/widgetDataTypes';

export default function Page() {
    return <DashboardContainer preconfiguredType={PRECONFIGURED_TYPES.CREATIVE} />;
}
